import {
    prepareResource,
    updateResource,
    resourceIsReady,
    getResource,
    getCachedResource,
    getResourceError,
    getResourceErrorDetail,
} from '@eb/resource-cache';
import { sdkRequest, dangerouslyFetchAllPages } from 'js-utils/http';

export const STATE_RESOURCE_CACHE_NAME = 'resourceCache';

export const makeCachedResourceTools = (buildUrl, options = {}) => {
    let {
        cacheId,
        transform: transformer,
        dangerouslyFetchAllPagesDataKey,
    } = options;

    if (!cacheId) {
        cacheId = STATE_RESOURCE_CACHE_NAME;
    }

    if (!transformer) {
        transformer = (response) => response;
    }

    return {
        buildUrl,
        prepare: (params, testValidity) => (dispatch) => {
            const url = buildUrl(params);
            let prepareFunction = () => sdkRequest(url).then(transformer);

            if (dangerouslyFetchAllPagesDataKey) {
                prepareFunction = () =>
                    dangerouslyFetchAllPages(
                        url,
                        dangerouslyFetchAllPagesDataKey,
                    ).then(transformer);
            }

            return prepareResource(
                dispatch,
                cacheId,
                url,
                prepareFunction,
                testValidity,
            );
        },
        update: (params, payload) => (dispatch) =>
            updateResource(dispatch, cacheId, buildUrl(params), payload),
        isReady: (state, params) =>
            resourceIsReady(state[cacheId], buildUrl(params)),
        getResource: (state, params, defaultValue) =>
            getResource(state[cacheId], buildUrl(params), defaultValue),
        getCachedResource: (state, params, defaultValue) =>
            getCachedResource(state[cacheId], buildUrl(params), defaultValue),
        getResourceError: (state, params) =>
            getResourceError(state[cacheId], buildUrl(params)),
        hasPermissionError: (state, params) => {
            const error = getResourceErrorDetail(
                state[cacheId],
                buildUrl(params),
            );

            return !!(error && error.response && error.response.status === 403);
        },
    };
};
